
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"192","height":"91","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".1","fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 0c2.601 50.695 44.53 91 95.872 91s93.271-40.305 95.872-91h-32.107l-.083 1.72-.849 5.547-1.274 4.586-1.698 3.787-1.911 3.04-2.122 2.4-2.229 1.76-2.229 1.28-2.123.853-1.91.48-1.699.267-1.273.107-.849-.054H95.766v4.374h30.992l.053 14.72.106 1.92-.266 1.813-.583 1.653-.902 1.547-1.327 1.333-1.645 1.28-2.017 1.067-2.335.907-2.706.8-3.078.693-3.397.48-3.767.373-4.087.214L96.35 59l-6.74-.213-5.678-.747-4.776-1.067-3.874-1.333-3.131-1.6-2.388-1.76-1.805-1.813-1.326-1.814-.85-1.76-.53-1.6-.212-1.333-.107-1.067.053-.693V13.72l.266-3.413.69-2.88 1.114-2.454 1.38-2.026 1.592-1.707L71.724 0H64.14l-.215.28-1.061 1.92-.796 1.973-.531 1.867-.371 1.707-.213 1.44-.106 1.12v16.32H49.013l-1.114-.16-1.486-.374-1.698-.64-1.858-.96-1.91-1.386-1.91-1.92-1.858-2.454-1.698-3.146-1.486-3.894L32.88 7l-.743-5.6-.056-1.4H0zm109.51 39.587l-1.22 1.76-.425 2.186.425 2.187 1.22 1.76 1.752 1.227 2.176.426 2.175-.426 1.752-1.227 1.22-1.76.425-2.187-.425-2.186-1.22-1.76-1.752-1.227-2.175-.427-2.176.427-1.752 1.227z","fill":"#0F8190"}})])
          )
        }
      }
    